require('./src/style/common.scss');

exports.onClientEntry = function() {
  try {
    if (!window) return
  } catch (e) {
    console.warn(e)
  }
}

exports.wrapPageElement = require('./gatsby-share');
